var map = {
	"./404.svg": "sEM+",
	"./accessory.svg": "DuEI",
	"./alarm.svg": "mMjV",
	"./appointment.svg": "+Npl",
	"./box.svg": "N5kO",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./coal.svg": "+jS7",
	"./component.svg": "s2cW",
	"./corn.svg": "ujfV",
	"./dashboard.svg": "BCGP",
	"./database.svg": "T380",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./edit.svg": "ql+d",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./exception.svg": "aJhA",
	"./exit-fullscreen.svg": "G+/G",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./fence.svg": "WBhp",
	"./filter.svg": "ObMl",
	"./form.svg": "sTIr",
	"./fullscreen.svg": "WIff",
	"./gate.svg": "6WwC",
	"./guide 2.svg": "kA1i",
	"./guide.svg": "z74U",
	"./home.svg": "U9Ws",
	"./icon.svg": "vUvT",
	"./intLog.svg": "prJH",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./logs.svg": "49QO",
	"./md.svg": "Z0w5",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./nested.svg": "798r",
	"./order.svg": "gYtG",
	"./page.svg": "zrC5",
	"./pallet.svg": "HWYI",
	"./password.svg": "QjmH",
	"./paycheck.svg": "+Mec",
	"./pdf.svg": "M8Oc",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./plan.svg": "0Ex+",
	"./qc.svg": "K96Z",
	"./qq.svg": "R2jY",
	"./queue.svg": "5ou9",
	"./report.svg": "2nwU",
	"./run.svg": "9Z5S",
	"./runMaintain.svg": "J1cM",
	"./search.svg": "Bx0U",
	"./service.svg": "nCjf",
	"./setting.svg": "Kttn",
	"./shopping.svg": "jRi0",
	"./sign.svg": "HE8u",
	"./size.svg": "Cr4N",
	"./star.svg": "60zo",
	"./tab.svg": "Jysk",
	"./table-setting.svg": "hTsv",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./toxin.svg": "nUl5",
	"./transfer.svg": "S35e",
	"./transport.svg": "EGRk",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./warehouse.svg": "BupX",
	"./wechat.svg": "pYJ+",
	"./weigh.svg": "hofw",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 225